(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brewing-instructions"] && !Shopify.designMode) return;
  try {
    
  var tabs = document.querySelectorAll(".tabs_wrap ul li");
    var hot = document.querySelectorAll(".hot");
    var cold = document.querySelectorAll(".cold");
    var all = document.querySelectorAll(".item_wrap");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        var tabval = tab.getAttribute("data-tabs");

        all.forEach((item) => {
          item.style.display = "none";
        });

        if (tabval == "hot") {
          hot.forEach((hot) => {
            hot.style.display = "block";
          });
        } else if (tabval == "cold") {
          cold.forEach((cold) => {
            cold.style.display = "block";
          });
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel"] && !Shopify.designMode) return;
  try {
    
var elem = document.querySelector('.custom-carousel');
var flkty = new Flickity( elem, {
   // options
  cellAlign: "center",
  contain: true,
  freeScroll: true,
  wrapAround: true,
});


  } catch(e) { console.error(e); }
})();
})();
